import AxiosClient from "@/app/repository/axios-client";
import Repository from "@/app/repository/repository-factory";

const AuthRepository = Repository.get("AuthRepository");
const EmployeeAccountRepository = Repository.get("EmployeeAccountRepository");

const STORAGE_KEYS = {
  token: "token",
  refreshToken: "refresh_token",
  refreshTokenExpiration: "refresh_token_expiration",
  user: "user",
  role: "role",
  apiReleaseInfo: "api_release_info",
};

const ROLES = {
  SUPER_ADMIN: "ROLE_SUPER_ADMIN",
  MANAGEMENT_EMPLOYEE: "ROLE_MANAGEMENT_EMPLOYEE",
  ADMINISTRATIVE_EMPLOYEE: "ROLE_ADMINISTRATIVE_EMPLOYEE",
  READONLY_EMPLOYEE: "ROLE_READONLY_EMPLOYEE",
  MEDICAL_EMPLOYEE: "ROLE_MEDICAL_EMPLOYEE",
};

export const AuthJwtService = {
  login,
  refreshProfile,
  logout,
  isGranted,
  isSuperAdmin,
  isManagementEmployee,
  isAdministrativeEmployee,
  isReadOnlyEmployee,
  isMedicalEmployee,
};

async function login(username, password) {
  try {
    const authResponse = await AuthRepository.login({ username, password });
    const data = authResponse && authResponse.data ? authResponse.data : {};

    if (!data.token) {
      throw data;
    }

    persistTokens(data);

    const meResponse = await EmployeeAccountRepository.getMe();
    const me = meResponse && meResponse.data ? meResponse.data : {};
    persistUser(me);

    return me;
  } catch (error) {
    const errorOut = (error && error.response && error.response.data && error.response.data.message) || error;
    logout();
    return Promise.reject(errorOut);

  }
}

function isGranted(role) {
  const currentRole = localStorage.getItem(STORAGE_KEYS.role);
  return currentRole === role;
}

async function refreshProfile() {
  const response = await EmployeeAccountRepository.getMe();
  persistUser(response.data);
  return response.data;
}

function isSuperAdmin() {
  return isGranted(ROLES.SUPER_ADMIN);
}

function isManagementEmployee() {
  return isGranted(ROLES.MANAGEMENT_EMPLOYEE);
}

function isAdministrativeEmployee() {
  return isGranted(ROLES.ADMINISTRATIVE_EMPLOYEE);
}

function isReadOnlyEmployee() {
  return isGranted(ROLES.READONLY_EMPLOYEE);
}

function isMedicalEmployee() {
  return isGranted(ROLES.MEDICAL_EMPLOYEE);
}

function setAuthHeader(token) {
  if (token) {
    AxiosClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
}

function persistTokens({ token, refresh_token, refresh_token_expiration }) {
  if (token) {
    localStorage.setItem(STORAGE_KEYS.token, token);
    setAuthHeader(token);

  }
  if (refresh_token) localStorage.setItem(STORAGE_KEYS.refreshToken, refresh_token);
  if (refresh_token_expiration)
    localStorage.setItem(STORAGE_KEYS.refreshTokenExpiration, refresh_token_expiration);
}

function persistUser(user) {
  localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user || {}));
  if (user && user.role) {
    localStorage.setItem(STORAGE_KEYS.role, user.role);
  }
}

function logout() {
  delete AxiosClient.defaults.headers.common["Authorization"];
  clearAuthStorage();
}

function clearAuthStorage() {
  localStorage.removeItem(STORAGE_KEYS.token);
  localStorage.removeItem(STORAGE_KEYS.refreshToken);
  localStorage.removeItem(STORAGE_KEYS.refreshTokenExpiration);
  localStorage.removeItem(STORAGE_KEYS.user);
  localStorage.removeItem(STORAGE_KEYS.role);
  localStorage.removeItem(STORAGE_KEYS.apiReleaseInfo);
}
